module.exports = __webpack_public_path__ + "img/icon-geography.12c3aa3a.png";